var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{staticClass:"mt-2",attrs:{"width":"600px","visible":_vm.isOpen,"append-to-body":true},on:{"update:visible":function($event){_vm.isOpen=$event}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }